import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Alert from '@material-ui/lab/Alert';
import Typography from '@material-ui/core/Typography';

const TransactionStatus = (props) => {
  const {
    status, errorCode, errorMessage, booking,
  } = props;

  if (!booking || !booking.id) {
    return null;
  }

  if (status === 'success' && booking.paid_at) {
    return (
      <Alert elevation={6} severity="success">
        <Typography>
          <FormattedMessage
            id="transaction.success"
            defaultMessage="Your payment was successful and the booking is now paid"
          />
        </Typography>
      </Alert>
    );
  }

  return (
    <>
      <Alert elevation={6} severity="error">
        <Typography>
          <FormattedMessage
            id="transaction.failure"
            defaultMessage="Your payment has failed, please contact Stugknutens support through email on {email} for assistance"
            values={{
              email: (
                <a
                  style={{ color: 'inherit' }}
                  href="mailto:info@stugknuten.com"
                >
                  info@stugknuten.com
                </a>
              ),
            }}
          />
        </Typography>
        {
          errorCode && errorMessage && (
            <Typography>
              <FormattedMessage id={`mango.error.${errorCode}`} defaultMessage={errorMessage} />
            </Typography>
          )
        }
      </Alert>
    </>
  );
};

TransactionStatus.propTypes = {
  status: PropTypes.oneOf(['success', 'failure']),
  errorCode: PropTypes.string,
  errorMessage: PropTypes.string,
  booking: PropTypes.shape({
    paid_at: PropTypes.string,
    id: PropTypes.number,
  }).isRequired,
};

export default TransactionStatus;
